import React from 'react';

import styles from './styles.module.scss';

const WebcamTips = ({ previewImage }) => {
  return (
    <div className={styles.boxContainer}>
      {!previewImage && (
        <>
          <div className={styles.line}>
            <p>1. 📄 Put your paper inside the box.</p>
            <span>(Keep it tall like a tower!)</span>
          </div>

          <p>2. ⌨️ Press the Spacebar OR 📸 Click the camera button.</p>
        </>
      )}
    </div>
  );
};

export default WebcamTips;
